module.exports = __webpack_public_path__ + "63eac43764e3f1b491a2845e92c2c8ab.png";